@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.promocodes
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.promocodes.PromoCodeDto
import com.narbase.letsgo.web.dto.ridepromocode.RidePromoCodeDto

object GetAvailablePassengerPromoCodesEndpoint :
    EndPoint<GetAvailablePassengerPromoCodesEndpoint.Request, GetAvailablePassengerPromoCodesEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
    )

    class Response(
        val activeRidePromoCodeId: KmmLong?,
        val availablePromoCodes: Array<RidePromoCodeDto>,
        val total: Int,
    )
}